<template>
    <v-row justify="center">
        <v-list-item  color="primary" dark>
            <v-btn  color="error" depressed x-large class="ml-5" @click="startInterview">Start Interview</v-btn>

        </v-list-item>


        <v-dialog   content-class="transformModal" v-model="dialog1"  width="390" persistent hide-overlay  no-click-animation>
            <v-card>
                <div class="decision-content">
                    <v-card-title class="decision-heading">Interview Session </v-card-title>

                    <v-card-text class="decision-info">
                        Record the interview response and give your feedback based on performance:
                    </v-card-text>
                    <div v-if="serverResponse" class="red--text mt-2 mb-2">
                        {{serverResponse}}

                    </div>
                    <div>
                        <ValidationObserver v-slot="{ handleSubmit }">
                            <v-form v-if="!submitted" @submit.prevent="handleSubmit(SubmitInterview)">


<!--                              Interview questions-->
                                <ValidationProvider name="input" rules="required" v-slot="{errors}">
                                    <span class="err">{{ errors[0] }}</span>
                                <v-textarea
                                        outlined
                                        name="input-7-4"
                                        class="ml-3 mr-2 decision-input"
                                        label='How did you hear about us?'
                                        v-model="interview['How did you hear about us?']"
                                        auto-grow
                                        row-height="15"
                                ><template v-slot:label><span class="v-label-white">How did you hear about us?</span></template ></v-textarea>
                                </ValidationProvider>
                                <ValidationProvider name="input" rules="required" v-slot="{errors}">
                                    <span class="err">{{ errors[0] }}</span>
                                    <v-textarea
                                            outlined
                                            name="input-7-4"
                                            class="ml-3 mr-2 decision-input"
                                            label='What are you passionate about?'
                                            v-model="interview['What are you passionate about?']"
                                            auto-grow
                                            row-height="15"
                                    ><template v-slot:label><span class="v-label-white">What are you passionate about?</span></template ></v-textarea>
                                </ValidationProvider>
                                <ValidationProvider name="input" rules="required" v-slot="{errors}">
                                    <span class="err">{{ errors[0] }}</span>
                                        <v-textarea
                                                outlined
                                                name="input-7-4"
                                                row-height="15"
                                                class="ml-3 mr-2 decision-input"
                                                label='Tell me about a situation where you had to solve a difficult problem?'
                                                v-model="interview['Tell me about a situation where you had to solve a difficult problem?']"
                                                auto-grow
                                        ><template v-slot:label><span class="v-label-white">Tell me about a situation where you had to solve a difficult problem?</span></template ></v-textarea>
                                </ValidationProvider>
                                <ValidationProvider name="input" rules="required" v-slot="{errors}">
                                    <span class="err">{{ errors[0] }}</span>
                                        <v-textarea
                                                outlined
                                                name="input-7-4"
                                                row-height="15"
                                                class="ml-3 mr-2 decision-input"
                                                label='What did you do?'
                                                v-model="interview['What did you do?']"
                                                auto-grow
                                        > <template v-slot:label><span class="v-label-white">What did you do?</span></template ></v-textarea>
                                </ValidationProvider>
                                <ValidationProvider name="input" rules="required" v-slot="{errors}">
                                    <span class="err">{{ errors[0] }}</span>
                                    <v-textarea
                                            outlined
                                            name="input-7-4"
                                            row-height="15"
                                            class="ml-3 mr-2 decision-input"
                                            label='What was the outcome?'
                                            v-model="interview['What was the outcome?']"
                                            auto-grow
                                    ><template v-slot:label><span class="v-label-white">What was the outcome?</span></template > </v-textarea>
                                </ValidationProvider>
                                <ValidationProvider name="input" rules="required" v-slot="{errors}">
                                    <span class="err">{{ errors[0] }}</span>
                                    <v-textarea
                                            outlined
                                            name="input-7-4"
                                            row-height="15"
                                            class="ml-3 mr-2 decision-input"
                                            label='What do you wish you had done differently?'
                                            v-model="interview['What do you wish you had done differently?']"
                                            auto-grow
                                    ><template v-slot:label><span class="v-label-white">What do you wish you had done differently?</span></template ></v-textarea>
                                </ValidationProvider>
                                <ValidationProvider name="input" rules="required" v-slot="{errors}">
                                    <span class="err">{{ errors[0] }}</span>
                                        <v-textarea
                                                outlined
                                                auto-grow
                                                name="input-7-4"
                                                row-height="15"
                                                class="ml-3 mr-2 decision-input"
                                                label='How was your transition from high school to university?'
                                                aria-multiline="true"
                                                v-model="interview['How was your transition from high school to university?']"
                                        ><template v-slot:label><span class="v-label-white">How was your transition from high school to university?</span></template ></v-textarea>
                                </ValidationProvider>

                              <ValidationProvider name="input" rules="required" v-slot="{errors}">
                                <span class="err">{{ errors[0] }}</span>
                                <v-textarea
                                    outlined
                                    auto-grow
                                    name="input-7-4"
                                    row-height="15"
                                    class="ml-3 mr-2 decision-input"
                                    label='Did you face any problems?'
                                    aria-multiline="true"
                                    v-model="interview['Did you face any problems?']"
                                ><template v-slot:label><span class="v-label-white">Did you face any problems?</span></template ></v-textarea>
                              </ValidationProvider>

                              <ValidationProvider name="input" rules="required" v-slot="{errors}">
                                    <span class="err">{{ errors[0] }}</span>
                                        <v-textarea
                                                outlined
                                                name="input-7-4"
                                                row-height="15"
                                                class="ml-3 mr-2 decision-input"
                                                label= 'How did you handle them?'
                                                v-model="interview['How did you handle them?']"
                                                auto-grow
                                        ><template v-slot:label><span class="v-label-white">How did you handle them?</span></template ></v-textarea>
                                </ValidationProvider>


                              <ValidationProvider name="input" rules="required" v-slot="{errors}">
                                <span class="err">{{ errors[0] }}</span>
                                <v-textarea
                                    outlined
                                    name="input-7-4"
                                    row-height="15"
                                    class="ml-3 mr-2 decision-input"
                                    label='What is an interesting thing you have learned, in and out of software engineering?'
                                    v-model="interview['What is an interesting thing you have learned, in and out of software engineering?']"
                                    auto-grow
                                ><template v-slot:label><span class="v-label-white">What is an interesting thing you have learned, in and out of software engineering?</span></template ></v-textarea>
                              </ValidationProvider>

                              <ValidationProvider name="input" rules="required" v-slot="{errors}">
                                <span class="err">{{ errors[0] }}</span>
                                <v-textarea
                                    outlined
                                    name="input-7-4"
                                    row-height="15"
                                    class="ml-3 mr-2 decision-input"
                                    label='What do you intend to do with the skill you acquire?'
                                    v-model="interview['What do you intend to do with the skill you acquire?']"
                                    auto-grow
                                ><template v-slot:label><span class="v-label-white">What do you intend to do with the skill you acquire?</span></template ></v-textarea>
                              </ValidationProvider>

                              <ValidationProvider name="input" rules="required" v-slot="{errors}">
                                <span class="err">{{ errors[0] }}</span>
                                <v-textare
                                    outlined
                                    name="input-7-4"
                                    row-height="15"
                                    class="ml-3 mr-2 decision-input"
                                    label='How do you feel about being part of the training program?'
                                    v-model="interview['How do you feel about being part of the training program?']"
                                    auto-grow
                                ><template v-slot:label><span class="v-label-white">How do you feel about being part of the training program?</span></template ></v-textare>
                              </ValidationProvider>

                              <ValidationProvider name="input" rules="required" v-slot="{errors}">
                                <span class="err">{{ errors[0] }}</span>
                                <v-textarea
                                    outlined
                                    name="input-7-4"
                                    row-height="15"
                                    class="ml-3 mr-2 decision-input"
                                    label='How do you intend to pay for the training?'
                                    v-model="interview['How do you intend to pay for the training?']"
                                    auto-grow
                                ><template v-slot:label><span class="v-label-white">How do you intend to pay for the training?</span></template ></v-textarea>
                              </ValidationProvider>

                              <ValidationProvider name="Cohort" rules="required" v-slot="{errors}">
                                <span class="err">{{ errors[0] }}</span>

                                  <v-select
                                      :items="cohortData"
                                      v-model="interview.cohort"
                                      item-text="cohortName"
                                      item-value="id"
                                      label="Cohort Assigned To"
                                      class="ml-3 mr-2 decision-input"
                                      outlined
                                  ></v-select>
                              </ValidationProvider>
                                <ValidationProvider name="input" rules="required" v-slot="{errors}">
                                    <span class="err">{{ errors[0] }}</span>

                                        <v-textarea
                                                outlined
                                                name="input-7-4"
                                                row-height="15"
                                                class="ml-3 mr-2 decision-input"
                                                label="Decision Comment"
                                                v-model="interview.message"
                                                auto-grow
                                        ></v-textarea>
                                </ValidationProvider>

                        <div class=" date-and-time-input-box decisionRec" v-on:click="sendOffer">
                    <p class="decidetext">Offer Admission </p>
                    <img v-if="interview.interviewDecision==='OFFERED_ADMISSION'" class="decision-radio" src='../../../../../assets/svg/check-circle.svg' alt="logo" />
                        <img v-else class="decision-radio" src='../../../../../assets/svg/uncheck-icon.svg' alt="logo" />

                    </div>

                    <div class=" date-and-time-input-box decisionRec" v-on:click="sendToCommunity">
                    <p class="decidetext">Send to Community</p>
                    <img v-if="interview.interviewDecision==='SEND_TO_COMMUNITY'" class="send-radio" src="../../../../../assets/svg/check-circle.svg" alt="logo"  />
                        <img v-else class="send-radio" src="../../../../../assets/svg/uncheck-icon.svg" alt="logo"  />

                    </div>
                                <div class="date-and-time-input-box decisionRec"  v-on:click="NotSure">
                                    <p class="decidetext"> I’m still not sure</p>
                                    <img v-if="interview.interviewDecision==='NOT_SURE'" class="decision-radio " src="../../../../../assets/svg/check-circle.svg" alt="logo"/>

                                    <img  v-else class="decision-radio uncheck" src="../../../../../assets/svg/uncheck-icon.svg" alt="logo"/>

                                </div>




                    <div class="date-and-time-input-box decisionRec"  v-on:click="BlackList">
                    <p class="decidetext">Blacklist</p>
                        <img v-if="interview.interviewDecision==='BLACKLIST'" class="blacklist-radio " src="../../../../../assets/svg/check-circle.svg" alt="logo"/>

                        <img  v-else class="blacklist-radio uncheck" src="../../../../../assets/svg/uncheck-icon.svg" alt="logo"/>

                    </div>


                    <v-card-actions>
                        <v-btn   color="red" outlined   x-large  @click="cancelInterview"> Cancel </v-btn>
                        <v-btn  color="error" depressed x-large type="submit" class="ml-5"> Submit </v-btn>
                    </v-card-actions>
                            </v-form>
                        </ValidationObserver>
                </div>
                </div>
            </v-card>
        </v-dialog>
    </v-row>
</template>

<script>
import {cancelInterview, getAllCohort, startInterview, stopInterview} from "../../../../../services/ApiServices";

    import axios from 'axios'
    import {mapGetters} from "vuex";
    export default {
        name: "DecisionDialog",
        data(){


            return{
                dialog1:false,
                interviewResponse:'',
                submitted: false,
                cohortData:[],
                interview :{
                  'How did you hear about us?':'',
                  'What are you passionate about?':'',
                  'Tell me about a situation where you had to solve a difficult problem?':'',
                  'What did you do?':'',
                  'What was the outcome?':'',
                  'What do you wish you had done differently?':'',
                  'How was your transition from high school to university?':'' ,
                  'Did you face any problems?':'',
                  'How did you handle them?':'',
                  'What is an interesting thing you have learned, in and out of software engineering?':'',
                  'What do you intend to do with the skill you acquire?':'',
                  'How do you feel about being part of the training program?':'',
                  'How do you intend to pay for the training?':'',
                  cohort: "",
                    interviewDecision:"",
                    message:'',
                }

            }
        },
        props:{
            serverResponse:{
                type:String
            }
        },
        methods:{
            SubmitInterview(){
               if(this.interview.interviewDecision !== '') {
                    const elderHeader = JSON.parse(sessionStorage.getItem('headers'))
                    const {interview, applicantEmail} = this
                    axios.post(stopInterview(applicantEmail), {interview}, {headers: elderHeader})
                        .then(res => {
                            this.serverResponds = res.data.message
                            this.dialog1 = false
                            this.$store.dispatch('fetchApplicantByEmail',this.applicantEmail)


                        })
                        .catch(err => {
                            this.dialog1 = true

                            this.serverResponds = err.response.data.message
                            console.log(err)
                        })
                }else{
                    this.serverResponds = "Please Select Interview Decision"
                }

            },
            cancelInterview(){
                const elderHeader = JSON.parse(sessionStorage.getItem('headers'))
                const {applicantEmail}= this
                console.log(applicantEmail)
                axios.post(cancelInterview(applicantEmail),"",{headers:elderHeader})
                .then(res=>{
                    this.dialog1=false
                    this.$store.dispatch('fetchApplicantByEmail',this.applicantEmail)
                    console.log(res)
                }).catch(err=>{
                    console.log(err)
                    this.dialog=true
                })



            },
            sendOffer: function () {
                this.interview.interviewDecision ='OFFERED_ADMISSION'

            },
            sendToCommunity:function () {
                this.interview.interviewDecision='SEND_TO_COMMUNITY'
            },
            NotSure:function () {
                this.interview.interviewDecision='NOT_SURE'

            },
            BlackList:function () {
                this.interview.interviewDecision='BLACKLIST'

            },
            startInterview(){
                const elderHeader = JSON.parse(sessionStorage.getItem('headers'))
                this.loading=true
                const {applicantEmail}=this;
                axios.post(startInterview(applicantEmail),"",{headers:elderHeader})
                    .then(res=>{
                        console.log(res.data)
                        this.interviewResponse=res.data.message;
                        this.dialog1=true

                    })
                    .catch(err=>{
                        this.loading=false
                        if(err.response===undefined){
                            alert("Check your internet connection and try again")

                        }else{
                            alert(err.response.data.message)

                        }

                    })
            },
          getAllAvailableCohort(){
            const elderHeader = JSON.parse(sessionStorage.getItem('headers'))
              axios.get(getAllCohort,{headers:elderHeader})
            .then(res=>{
              this.cohortData=res.data
            })
            .catch(err=>{
              console.log(err)
            })

            return this.cohortData;

          }
        },

        computed: {

            ...mapGetters(['applicantEmail'])
        },

        mounted() {
          this.getAllAvailableCohort();
        }

    }
</script>

<style scoped>


    .decision{
        color: #00A998;
        font-style: normal !important;
        font-weight: 500 !important;
        font-size: 16px !important;
        line-height: 20px !important;
        display: flex;
        align-items: center !important;
        letter-spacing: 0.02em;

    }
    .err {
        color: red !important;
    }
    .decision-box{
        background: #C3F7E8;
        border-radius: 8px;
        padding: 3px;
    }
    .decision-heading{
        font-weight: 500!important;
        font-size: 30px !important;
        line-height: 33px!important;
        letter-spacing: -0.02em;
        color: #2B1C1C !important;
    }
    .decision-info{
        font-size: 14px !important;
        line-height: 18px !important;
        color: #2B1C1C;
    }
    .decision-input{
        font-size: 16px !important;
        line-height: 20px !important;
        display: flex;
        align-items: center!important;
        letter-spacing: 0.05em;


        color: #2B1C1C !important;
    }
    .box{
        box-shadow: none!important;
        cursor: pointer;
    }
    .decision-content{
        margin-left: 30px;
        margin-right: 30px;
        font-family: IBM Plex Sans !important;
        font-style: normal!important;
        font-weight: normal;

    }
    .decisionRec{
        box-shadow: 0px 8px 12px rgba(108, 132, 120, 0.1);

    }
    .decision-radio{

        margin-left: 80px !important;

    }
    .blacklist-radio{

        margin-left: 130px !important;

    }


    .date-and-time-input-box {
        display: flex;
        border: 1.5px solid rgba(150, 12, 12, 0.5);
        max-width: 305px;
        margin-left: 12px;
        border-radius: 6px;
        align-items: center;
        margin-bottom: 15px;
    }
    .date-and-time-input-box img {
        width: 20px;
        height: 20px;
        flex: 1;
    }
    .uncheck .decisionRec{
        border: 1px solid rgba(43, 28, 28, 0.25)!important;
    }

    .send-radio{
        margin-left: 58px !important;
    }
    .decidetext{
        margin-top: 12px !important;
        margin-left: 10px;


    }
    .v-label-white{
      font-size: 12px ;
      line-height: 25px;
      letter-spacing: 0.03em;


    }





</style>